module.exports = __webpack_public_path__ + "img/teams-right-arrow.dae7d083.svg";